module.exports = __webpack_public_path__ + "img/BMWM11965.5c474319.jpg";